import { Vehicle } from '../../models';
import { VehicleIcon } from '../icons/VehicleIcon';

type SidebarVehicleHeadlineProps = {
  vehicle: Vehicle;
};

export const SidebarVehicleHeadline = ({
  vehicle,
}: SidebarVehicleHeadlineProps) => {
  return (
    <h5>
      <span className={'text-color-dark white-space-nowrap'}>
        <VehicleIcon
          type={vehicle.type}
          className={'margin-right-5'}
        />
        <span className={'margin-right-5'}>{vehicle.name}</span>
      </span>
    </h5>
  );
};
